<div [id]="scrollerID"
     class="gd-scroller">
  <div class="gd-scroller__scrolling-area"
       [class.vertical]="defaultScrollConfig.scrollX">
    <ng-content></ng-content>
  </div>
</div>
